import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { parse } from 'csv-parse/browser/esm';
import { Component } from 'react';
import { Alert, AlertTitle, Grid, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import { DropzoneArea } from 'react-mui-dropzone';
import { uploadJsonCSV } from '../helpers/helper';

class CSVUploadFormDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            responseMsg: null,
            csvToUpload: null
        }

        // Bind
        this.handleError = this.handleError.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    componentDidMount() {
        this.props.handleDialog(this.handleOpen);
    }

    handleError = err => {
        console.error(err)
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    handleOpen = (/*entity*/) => {
        this.setState({
            open: true,
            responseMsg: null,
            csvToUpload: null
        });
    }

    handleUploadCSV = async () => {
        const { t, onUploadSuccess  } = this.props;
        if (this.state.csvToUpload !== null) {
            let projectId = this.props.projectId

            const response = await uploadJsonCSV(projectId, {csv: this.state.csvToUpload})
                .then((data) => {
                    return {
                        status: 200,
                        statusText: t("upload_ok_msg"),
                        data: data.data
                    };
                })
                .catch((err) => {
                    let beError = err?.response?.data?.message;
                    return {
                        status: err.status,
                        statusText: beError ? beError : err.message
                    };
                });
                this.setState({ responseMsg: response });

                if (response.status === 200 && onUploadSuccess) {
                    onUploadSuccess(response.data.rows); // Notifica il dad component(MainLayout) del success del UPLOAD
                }
        }
    }

    render() {
        const { t } = this.props;
        const { responseMsg } = this.state;

        return (
            <Dialog
                fullScreen={this.props.isDesktop}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{t("upload_csv")}</DialogTitle>
                <DialogContent>{responseMsg === null ? (
                    <DropzoneArea
                        acceptedFiles={['text/csv', 'application/csv']}
                        dropzoneText={t("upload_csv_msg_info_area")}
                        dropzoneClass="umpi-upload-dropzone-container"
                        filesLimit={1}
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        onChange={(e) => {
                            if (e.length <= 0) {
                                return;
                            }

                            // Prepare reader
                            const reader = new FileReader();

                            // On load parse as json
                            reader.onload = () => {
                                // Parse to json
                                parse(reader.result, (err, data) => {
                                    this.setState({ csvToUpload: data });
                                });
                            };

                            // Read stream from device
                            reader.readAsText(e[0]);
                        }}
                        onDelete={() => { this.setState({ csvToUpload: null }) }}
                    />
                ) : (
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        {responseMsg.status !== 200 ? (
                            <Alert severity="error">
                                <AlertTitle>{t("Error")}</AlertTitle>
                                {responseMsg.statusText}
                            </Alert>
                        ) : (
                            <Alert severity="success">
                                <AlertTitle>{t("Success")}</AlertTitle>
                                {responseMsg.statusText}
                            </Alert>
                        )}
                    </Stack>
                )}</DialogContent>
                <DialogActions>
                    {responseMsg === null ? (
                        <Grid container spacing={2} columns={2}>
                            <Grid item xs={1} style={{ textAlign: "left" }}>
                                <span>&nbsp;</span>
                            </Grid>
                            <Grid item xs={1} style={{ textAlign: "right" }}>
                                <Button onClick={this.handleClose}>
                                    {t("cancel")}
                                </Button>
                                <Button
                                    disabled={this.state.csvToUpload === null}
                                    onClick={this.handleUploadCSV} >
                                    {t("upload")}
                                </Button>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container spacing={2} columns={1}>
                            <Grid item xs={1} style={{ textAlign: "center" }}>
                                <Button onClick={this.handleClose}>
                                    {t("close")}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

function CSVUploadForm(props) {
    // Get flag desktop
    const isDesktop = useMediaQuery(useTheme().breakpoints.down('md'));
    // Inject media query + i18n
    return (
        <CSVUploadFormDialog
            {...props}
            isDesktop={isDesktop}
        />
    );
}

export default withTranslation()(CSVUploadForm);
